/* unplugin-vue-components disabled */import { render } from "./start.vue?vue&type=template&id=72d71d68&scoped=true&ts=true"
import script from "./start.vue?vue&type=script&lang=ts"
export * from "./start.vue?vue&type=script&lang=ts"

import "./start.vue?vue&type=style&index=0&id=72d71d68&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d71d68"]])

export default __exports__